/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Category_PhonesInputs */

const he_home_category_phones = /** @type {(inputs: Home_Category_PhonesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`טלפונים`)
};

const en_home_category_phones = /** @type {(inputs: Home_Category_PhonesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phones`)
};

/**
* | output |
* | --- |
* | "Phones" |
*
* @param {Home_Category_PhonesInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const home_category_phones = /** @type {((inputs?: Home_Category_PhonesInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Category_PhonesInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_home_category_phones(inputs)
	return en_home_category_phones(inputs)
});